import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectDropDownComponent } from './ngx-select-dropdown.component';
import { LimitToPipe } from '../../pipes/limit-to.pipe';
import { ArrayFilterPipe } from '../../pipes/filter-by.pipe';
import { SvgIconModule } from '@customcomponent/Icons/_svg/app-jt-svg-icon.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [SelectDropDownComponent, LimitToPipe, ArrayFilterPipe],
  imports: [CommonModule, FormsModule, SvgIconModule, InfiniteScrollModule],
  exports: [SelectDropDownComponent, LimitToPipe],
  bootstrap: []
})
export class SelectDropDownModule { }
